import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/styles';
import {
    Typography,
    Accordion, AccordionSummary, AccordionDetails, IconButton, Switch
} from '@material-ui/core';
import { Tune as FilterIcon } from '@material-ui/icons';

import LayerStyles from './LayerStyles';
import LayerFiltersReduxWrapper from './LayerFiltersReduxWrapper';
import LayerFilters from './LayerFilters';

const S3 = 'https://landhawk.s3.eu-west-1.amazonaws.com'; // Should be switched to env or url on image

const propTypes = {
    layer: PropTypes.object.isRequired,
    thumbnail: PropTypes.bool,
    filters: PropTypes.object,
    onSetFilters: PropTypes.func,
    isActive: PropTypes.bool.isRequired,
    onToggleActive: PropTypes.func.isRequired
};

const defaultProps = {
    thumbnail: true,
    filters: null,
    onSetFilters: null
};

const useStyles = makeStyles((theme) => styles(theme));

function QuickSelect ({ layer, thumbnail, filters, onSetFilters, isActive, onToggleActive }) {
    const classes = useStyles();
    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
        setIsExpanded(isActive);
    }, [isActive]);

    function toggleFilters () {
        setIsExpanded(!isExpanded);
    }

    const filterFields = layer.filterConfig ? layer.filterConfig.fields : null;

    return (
        <Accordion
            classes={{
                root: classes.root,
                expanded: classes.expanded
            }}
            expanded={isExpanded}
        >
            <AccordionSummary classes={{
                root: classes.summaryRoot,
                content: classes.summaryContent
            }}>
                {thumbnail && <div className={classes.imageWrapper}>
                    <img
                    className={classes.summaryImage}
                    src={`${S3}/layer/${layer.system_name}.jpg`}
                    alt={layer.name}
                />
                </div>}
                <div className={classes.summary}>
                    <div className={classes.summaryTitle}>
                        <Typography variant="body1">
                            {layer.name}
                        </Typography>
                        {
                            layer.styles && layer.styles.length > 1 && <LayerStyles layer={layer} />
                        }
                        {
                            filterFields && <IconButton
                                className={classnames(classes.filterButton, isExpanded && classes.filterButtonActive)}
                                onClick={toggleFilters}
                            >
                                <FilterIcon />
                            </IconButton>
                        }
                        <Switch
                            checked={isActive}
                            onChange={onToggleActive}
                        />
                    </div>
                    {layer.description && <Typography className={classes.summaryDescription} variant="body2">
                        {layer.description}
                    </Typography>}
                </div>
            </AccordionSummary>
            <AccordionDetails classes={{ root: classes.detailsRoot }}>
                {/* If not onSetFilters callback not provided then automatically use Redux with regular layers otherwise the parenet element should handle */}
                { layer.system_name && filterFields && (onSetFilters ?
                    <LayerFilters systemName={layer.system_name} fields={filterFields} filters={filters} onSetFilters={onSetFilters} /> :
                    <LayerFiltersReduxWrapper systemName={layer.system_name} />)
                }
            </AccordionDetails>
        </Accordion>
    );
}

const styles = theme => ({
    root: {
        '&:before':{
            height: 0
        },
        '&$expanded': {
            margin: 0
        },
        margin: 0,
        borderRadius: 5,
        overflow: 'hidden',
        border: `1px solid ${theme.palette.background.border}`,
        boxShadow: 'none',
        backgroundColor: 'transparent'
    },
    expanded: {},
    summaryRoot:{
        padding: 0,
        minHeight: '0 !important'

    },
    imageWrapper: {
        width: `100px`,
        minHeight: `100%`,
        display: `flex`,
    },
    summaryImage: {
        flex: 1,
        objectFit: `cover`,
        height: `100%`,
        maxWidth: `100%`,
    },
    summary: {
        flex: 2,
        padding: 10
        // paddingLeft: 10,
        // paddingRight: 10
    },
    summaryTitle: {
        display: 'flex',
        alignItems: 'center',
        '& > *:first-child': {
            marginRight: 'auto'
        }
    },
    filterButton: {
        color: theme.palette.grey.variant3,
        padding: 0,
        marginRight: theme.constants.horizontalMargin
    },
    filterButtonActive: {
        color: theme.palette.text.primary
    },
    summaryDescription: {
        color: theme.palette.grey.variant4,
        marginTop: 10
    },
    summaryContent: {
        margin: '0 !important'
    },
    detailsRoot: {
        flexDirection: 'column',
        padding: `${theme.constants.verticalMargin}px ${theme.constants.horizontalMargin}px`,
        borderTop: `1px solid ${theme.palette.background.border}`
    }
});

QuickSelect.propTypes = propTypes;
QuickSelect.defaultProps = defaultProps;

export default QuickSelect;